export default __webpack_public_path__ + "static/media/md-card-bg-scrum.a4d00eb2.png";